"use client";

import { useEffect } from "react";
import { usePathname, useSearchParams } from "next/navigation";

let vConsoleInstance: { hide: () => void; destroy: () => void } | null = null;
let isLoading = false;

const DebuggerProvider = () => {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    const debugParam = searchParams.get("debug");
    const isDebug = debugParam === "1";

    // Sync sessionStorage with URL (no persistence)
    if (isDebug) {
      sessionStorage.setItem("debug", "1");
    } else {
      sessionStorage.removeItem("debug");
    }

    if (isDebug && !vConsoleInstance && !isLoading) {
      isLoading = true;
      import("vconsole")
        .then((mod) => {
          if (!vConsoleInstance) {
            vConsoleInstance = new mod.default({ theme: "dark" });
            vConsoleInstance.hide();
          }
          isLoading = false;
        })
        .catch(() => {
          isLoading = false;
        });
    }

    if (!isDebug && vConsoleInstance) {
      vConsoleInstance.destroy();
      vConsoleInstance = null;
    }
  }, [pathname, searchParams]);

  return null;
};

export default DebuggerProvider;
